module.exports = __webpack_public_path__ + "img/aloevera_wirkung.41dc1999.jpg";